import {
  faBars,
  faBlog,
  faCalendarAlt,
  faClock,
  faCode,
  faEdit,
  faEnvelope,
  faExclamation,
  faHeart,
  faInfo,
  faLaptopCode,
  faLightbulb,
  faPen,
  faProjectDiagram,
  faRadiation,
  faRocket,
  faRss,
  faQuoteLeft,
  faQuoteRight,
  faShareAlt,
  faSpaceShuttle,
  faUser,
  faUserGraduate,
  faTag,
} from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import { library } from '@fortawesome/fontawesome-svg-core'

export const loadIcons = (): void => {
  library.add(
    faBars,
    faBlog,
    faCalendarAlt,
    faClock,
    faCode,
    faEdit,
    faEnvelope,
    faExclamation,
    faHeart,
    faInfo,
    faLaptopCode,
    faLightbulb,
    faPen,
    faProjectDiagram,
    faRadiation,
    faRocket,
    faRss,
    faQuoteLeft,
    faQuoteRight,
    faShareAlt,
    faSpaceShuttle,
    faUser,
    faUserGraduate,
    faTag,
    fab
  )
}
